export default __webpack_public_path__ + "7bbce7dcca09c9ec0132d9c1630b0343.webp";